// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// components
import EntityEditForm from '_components/entity-edit-form/index.jsx'

const PersonPage = (props) => {
  useRetractSidebar()

  return (
    <div id="person-page">
      <EntityEditForm
        entities="people"
        id={props.match.params.id}
        fields={[
          { name: 'name' },
          { name: 'email' },
          { name: 'phone' },
          { name: 'company' },
          { name: 'department' },
          { name: 'position' },
        ]}
        resource="People"
      />
    </div>
  )
}

export default PersonPage
